module.exports = __webpack_public_path__ + "static/sui-table-contextual-styles1-2fd3e893be22eeeb22dbcd3987a754a5.png";